<template>
    <div class="famous-comment-popup famous-comment-popup-report">
        <van-popup :value="showPediaCommentReport" position="bottom" @click-overlay="clickClose">
            <!-- 1. 关闭按钮 -->
            <div class="famous-comment-report-close" @click="clickClose">
                <i class="iconfont icon-guanbi"></i>
            </div>
            <!-- 2. 举报选择列表 -->
            <div v-if="showSelectList && !showPediaCommentReportSuc" class="famous-comment-report-list">
                <div v-for="reportData in reportList" v-bind:key="'report'+reportData.type" class="famous-crli-item" @click="clickSelectReport(reportData.type)">
                    <span>{{reportData.text}}</span><i class="iconfont icon-xiangyou"></i>
                </div>
            </div>
            <!-- 3. 举报输入框 -->
            <div v-if="!showSelectList && !showPediaCommentReportSuc" class="famous-comment-report-textarea-box">
                <textarea class="famous-comment-report-textarea" placeholder="举报详细说明(选填)" name="" id="ReportTextarea" cols="30" rows="10" maxlength="150" v-model="textValue" @input="inputTextArea"></textarea>
                <div v-if="textValueTooLong" class="famous-comment-report-textarea-note">举报内容不得超过150字</div>
            </div>

            <!-- 4. 操作按钮区域 -->
            <div v-if="!showSelectList && !showPediaCommentReportSuc" class="famous-comment-report-button">
                <button class="famous-crb-report-d" @click="clickBack">返回</button>
                <button class="famous-crb-report-b" @click="clickReport">举报</button>
            </div>

            <!-- 5. 举报成功提示信息 -->
            <div v-if="showPediaCommentReportSuc" class="famous-comment-report-suc">
                <div class="famous-comment-report-icon">
                    <i class="iconfont icon-selected"></i>
                </div>
                <div class="famous-comment-report-note">
                    <p>你的举报我们已经收到，处理结果会通过</p>
                    <p>百科通知进行告知。</p>
                </div>
                <div class="famous-comment-report-sub">
                    <p>右上角「消息通知」-「百科通知」-「<span class="famous-crs-note">举报</span>」中查询进度</p>
                </div>
            </div>
        </van-popup>
    </div>
</template>

<script>
export default {
    name: 'FamousCommentReport',
    computed: {
        showPediaCommentReport() {
            return this.$store.state.famouspediacomment.showPediaCommentReport;
        },
        showPediaCommentReportSuc() {
            return this.$store.state.famouspediacomment.showPediaCommentReportSuc;
        }
    },
    data() {
        return {
            reportList: [
                {type: 1, text: '垃圾广告信息'},
                {type: 2, text: '不友善行为'},
                {type: 3, text: '有害信息'},
                {type: 4, text: '涉嫌侵权'},
            ],
            selectedReportType: 1,
            textValue: '',
            textValueTooLong: false,
            showSelectList: true,
        }
    },
    mounted() {
        this.$bus.on('updateCommentReport', this.resetStatus)
    },
    destroyed() {
        this.$bus.off('updateCommentReport', this.resetStatus)
    },
    methods: {
        resetStatus() {
            this.showSelectList = true;
            this.textValue = '';
            this.textValueTooLong = false;
        },
        clickClose() {
            this.$store.state.famouspediacomment.showPediaCommentReport = false;
            this.$store.state.famouspediacomment.showPediaCommentReportSuc = false;
        },
        clickSelectReport(type) {
            this.showSelectList = false;
            this.selectedReportType = type;
        },
        clickBack() {
            this.showSelectList = true;
        },
        clickReport() {
            var me = this,
                baikeId = this.$store.state.famouspedia.curPediaBaziId;
            console.log('clickReport-----', this.textValue, this.selectedReportType, baikeId)
            this.$store.dispatch('famouspediacomment/reportComment', {
                bid: baikeId,
                msg: this.textValue,
                type: this.selectedReportType,
                cb: function() {
                    me.showSelectList = true;      
                }
            })
        },
        inputTextArea() {

        }
    }
}
</script>